// duplicate of libs\locations\src\lib\types\params.enum.ts to avoid having to import libs/locations
export enum EnumParams {
  Add = 'add',
  Edit = 'edit',
  Upload = 'upload-csv',
  LatestUpload = 'latest-upload',
  Export = 'export',
}
